module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "totalSlide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shown),
      expression: "shown"
    }],
    staticClass: "billcount-detail-total",
    on: {
      "click": _vm.moveAni
    }
  }, [_c('ul', {
    staticClass: "ui-listview",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('p', {
    staticClass: "allorderbill-list-p"
  }, [_vm._v("合计：\n\t\t\t\t\t\t"), _c('span', [_vm._v("共计" + _vm._s(_vm.totalSum.organ_num) + "家" + _vm._s(_vm.name))])]), _vm._v(" "), _c('ul', {
    staticClass: "ui-detail-listview ui-billcount-detail-listview"
  }, [_c('li', [_vm._v("订货金额：" + _vm._s(_vm.totalSum.order_bill_money) + "元")]), _vm._v(" "), _c('li', [_vm._v("实收金额：" + _vm._s(_vm.totalSum.sum_money_recipient) + "元")]), _vm._v(" "), _c('li', [_vm._v("订货单：共" + _vm._s(_vm.totalSum.order_bill_num) + "张")]), _vm._v(" "), _c('li', [_vm._v("发货金额：" + _vm._s(_vm.totalSum.deliver_money) + "元")]), _vm._v(" "), _c('li', [_vm._v("退货单：共" + _vm._s(_vm.totalSum.reverse_bill_num) + "张")]), _vm._v(" "), _c('li', [_vm._v("退货金额：" + _vm._s(_vm.totalSum.reverse_money) + "元")]), _vm._v(" "), _c('li', [_vm._v("发货减实收：" + _vm._s(_vm._f("filterFloat")((_vm.totalSum.deliver_money - _vm.totalSum.sum_money_recipient))) + "元")]), _vm._v(" "), _c('li', [_vm._v("实收减退货：" + _vm._s(_vm._f("filterFloat")((_vm.totalSum.sum_money_recipient - _vm.totalSum.reverse_money))) + "元")])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.shown),
      expression: "!shown"
    }],
    staticClass: "edi-total-second",
    on: {
      "click": _vm.getTotal
    }
  }, [_vm._v("合计")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06241427!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GetTotal.vue
// module id = 529
// module chunks = 1